import { Language } from '@/utilities/language';

export const TYPE = process.env.VUE_APP_TYPE || 'development';
export const VUE_APP_GTM_TOKEN = process.env.VUE_APP_GTM_TOKEN || 'GTM-DEVMODE';
export const OTLP_COLLECTOR_BASE = process.env.PUBLIC_OTLP_COLLECTOR_BASE || '';
export const API_BASE = process.env.PUBLIC_API_BASE_URL;
export const PRODUCTION = process.env.NODE_ENV === 'production';
export const VUE_APP_BASE_URL = process.env.VUE_APP_BASE_URL;

export const LANGUAGE: Language =
  process.env.VUE_APP_LANGUAGE === Language.Slovak ||
  process.env.VUE_APP_LANGUAGE === Language.Czech
    ? (process.env.VUE_APP_LANGUAGE as Language)
    : Language.Czech;

export const OTHER_APP_BASE_URL = process.env.PUBLIC_OTHER_APP_BASE_URL;
